var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64172 6.19922L10.0001 10.4576L17.3084 6.22422",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0076V10.4492",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9917 11.0411V12.3578C1.9917 13.5078 2.8167 14.9078 3.82503 15.4661L8.27503 17.9411C9.22503 18.4661 10.7834 18.4661 11.7334 17.9411L16.1834 15.4661C17.1917 14.9078 18.0167 13.5078 18.0167 12.3578V7.64115C18.0167 6.49115 17.1917 5.09115 16.1834 4.53281L11.7334 2.05781C10.7834 1.53281 9.22503 1.53281 8.27503 2.05781L3.82503 4.53281C2.8167 5.09115 1.9917 6.49115 1.9917 7.64115",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenBox);
export default __webpack_public_path__ + "static/media/brokenBox.5e59d80766a9300a4804eefd2c1a63c8.svg";
export { ForwardRef as ReactComponent };